<template>
  <v-layout row wrap transparent :class="$vuetify.breakpoint.smAndDown ? 'px-1' : 'px-5'"
    v-if="$route.path !== '/register' &&
      $route.path !== `/register/${ $route.params.token }` &&
      $route.path !== '/login' &&
      $route.path !== `/login/${ $route.params.token }` &&
      $route.path !== '/forgot-password' &&
      $route.path !== `/reset-password/${ $route.params.token }` &&
      $route.path !== '/site-notice' &&
      $route.path !== '/privacy-policy'"
    >
    <v-spacer class="hidden-sm-and-down"></v-spacer>
    <v-flex xs12 md10>
      <v-toolbar dark color="transparent" height="80" class="elevation-0 hidden-sm-and-down">
        <router-link to="/job/browse">
          <img src="../assets/img/white_blueBackground_Text_small.png" height="64px" alt="logo">
        </router-link>
        <v-toolbar-items class="hidden-sm-and-down pl-5">
          <!-- <v-btn flat class="text-capitalize" to="/job/browse">Home</v-btn> -->
          <v-menu offset-y bottom open-on-hover v-if="isLoggedIn">
            <v-btn flat class="text-capitalize" slot="activator">My Jobs</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile to="/company/manage-jobs">Manage</v-list-tile>
                <v-list-tile to="/job/create">Create</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom open-on-hover  v-if="isLoggedIn">
            <v-btn flat class="text-capitalize" slot="activator">My Publishers</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile to="/company/apply-to-publisher">Apply</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu v-if="isLoggedIn && (isPublisher || (isAdmin && currentUser.publisher_id))" offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Publishing Management</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile to="/publisher/edit">My Publisher</v-list-tile>
                <v-list-tile to="/publisher/manage-jobs">Manage Jobs</v-list-tile>
                <v-list-tile to="/publisher/manage-organisations">Manage Organisations</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu v-if="isLoggedIn && isAdmin" offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Admin</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile to="/admin/manage-jobs">Manage Jobs</v-list-tile>
                <v-list-tile to="/admin/manage-organisations">Manage Organisations</v-list-tile>
                <v-list-tile to="/admin/manage-publishers">Manage Publishers</v-list-tile>
                <v-list-tile to="/admin/manage-users">Manage User</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <!-- <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">User</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="!isLoggedIn" to="/register">Register</v-list-tile>
                <v-list-tile v-if="!isLoggedIn" to="/login">Login</v-list-tile>
                <v-list-tile v-if="!isLoggedIn" to="/forgot-password">Forgot password</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/user/edit">Edit</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Organisation</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="isLoggedIn" to="/company/edit">Edit</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/company/detail">Detail</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/company/apply-to-publisher">Apply to Publishers</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/company/manage-jobs">Manage Jobs</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Publisher</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="isLoggedIn" to="/publisher/edit">Edit</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/publisher/manage-organisations">Manage Organisations</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/publisher/manage-jobs">Manage Jobs</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Admin</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="isLoggedIn" to="/admin/manage-users">User list</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/admin/manage-organisations">Organisations list</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/admin/manage-publishers">Publishers list</v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">Job</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="isLoggedIn" to="/job/create">Create</v-list-tile>
                <v-list-tile to="/job/browse">Browse</v-list-tile>
              </v-list>
            </v-card>
          </v-menu> -->
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <div v-if="!isLoggedIn">
          <v-btn class="elevation-0 text-capitalize" style="background-color: #38b0fe !important" to="/login">Log in</v-btn>
          or
          <v-btn flat class="text-capitalize" to="/register">Register</v-btn>
        </div>
        <div v-if="isLoggedIn">
          <v-menu offset-y bottom :disabled="getStatus.loading">
            <v-btn flat class="text-lowercase" slot="activator">{{getStatus.loading ? 'loading...' : currentUser.email}}</v-btn>
            <v-card>
            <v-list class="white grey--text text--darken-1" dense>
              <v-list-tile v-if="isLoggedIn" to="/company/edit">My Organisation</v-list-tile>
              <v-list-tile v-if="isLoggedIn" to="/user/edit">My Profile</v-list-tile>
              <v-list-tile v-if="isLoggedIn" @click="logout">Logout</v-list-tile>
            </v-list>
          </v-card>
          </v-menu>
        </div>
      </v-toolbar>
      <v-toolbar dark color="transparent" height="80" class="elevation-0 hidden-md-and-up">
        <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
        <router-link to="/job/browse">
          <img src="../assets/img/white_blueBackground_Text_small.png" style="width: 160px; height: 40px" class="mx-3" alt="logo">
        </router-link>
        <v-spacer></v-spacer>
        <!-- <div v-if="!isLoggedIn">
          <v-btn class="elevation-0 text-capitalize" style="background-color: #38b0fe !important" to="/login">Log in</v-btn>
          or
          <v-btn flat class="text-capitalize" to="/register">Register</v-btn>
        </div> -->
        <!-- <div v-if="isLoggedIn">
          <v-menu offset-y bottom :disabled="getStatus.loading">
            <v-btn flat :class="$vuetify.breakpoint.smAndDown ? 'text-lowercase caption' : 'text-lowercase'" slot="activator">{{getStatus.loading ? 'loading...' : currentUser.email}}</v-btn>
            <v-card>
            <v-list class="white grey--text text--darken-1" dense>
              <v-list-tile v-if="isLoggedIn" to="/company/edit">My Organisation</v-list-tile>
              <v-list-tile v-if="isLoggedIn" to="/user/edit">My Profile</v-list-tile>
              <v-list-tile v-if="isLoggedIn" @click="logout">Logout</v-list-tile>
            </v-list>
          </v-card>
          </v-menu>
        </div> -->
      </v-toolbar>
      <v-navigation-drawer persistent v-model="drawer" clipped fixed disable-resize-watcher>
        <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
        <router-link to="/job/browse">
          <img src="../assets/img/blue_whiteBackground_Text_WEB.jpg" style="width: 142px; height: 36px; vertical-align: middle" class="mx-1" alt="logo">
        </router-link>
        <v-divider></v-divider>
        <v-list>
          <!-- <v-menu offset-y bottom open-on-hover>
            <v-btn flat class="text-capitalize" slot="activator">My Jobs</v-btn>
            <v-card>
              <v-list class="white grey--text text--darken-1" dense>
                <v-list-tile v-if="isLoggedIn" to="/company/manage-jobs">Manage</v-list-tile>
                <v-list-tile v-if="isLoggedIn" to="/job/create">Create</v-list-tile>
              </v-list>
            </v-card>
          </v-menu> -->
          <v-list-group no-action v-if="isLoggedIn">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>My Jobs</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/company/manage-jobs">Manage</v-list-tile>
            <v-list-tile to="/job/create">Create</v-list-tile>
          </v-list-group>

          <v-list-group no-action v-if="isLoggedIn">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>My Publishers</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/company/apply-to-publisher">Apply</v-list-tile>
          </v-list-group>

          <v-list-group no-action v-if="isLoggedIn && (isPublisher || (isAdmin && currentUser.publisher_id))">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Publishing Management</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/publisher/edit">My Publisher</v-list-tile>
            <v-list-tile to="/publisher/manage-jobs">Manage Jobs</v-list-tile>
            <v-list-tile to="/publisher/manage-organisations">Manage Organisations</v-list-tile>
          </v-list-group>

          <v-list-group no-action v-if="isLoggedIn && isAdmin">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Admin</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile to="/admin/manage-jobs">Manage Jobs</v-list-tile>
            <v-list-tile to="/admin/manage-organisations">Manage Organisations</v-list-tile>
            <v-list-tile to="/admin/manage-publishers">Manage Publishers</v-list-tile>
            <v-list-tile to="/admin/manage-users">Manage User</v-list-tile>
          </v-list-group>

          <v-list-group no-action v-if="isLoggedIn">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{getStatus.loading ? 'loading...' : currentUser.email}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/company/edit">My Organisation</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/user/edit">My Profile</v-list-tile>
            <v-list-tile v-if="isLoggedIn" @click="logout">Logout</v-list-tile>
          </v-list-group>

          <v-list-tile v-if="!isLoggedIn" to="/register">Register</v-list-tile>
          <v-list-tile v-if="!isLoggedIn" to="/login">Log In</v-list-tile>

          <!-- USER GROUP -->
          <!-- <v-list-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>User</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="!isLoggedIn" to="/register">Register</v-list-tile>
            <v-list-tile v-if="!isLoggedIn" to="/login">Login</v-list-tile>
            <v-list-tile v-if="!isLoggedIn" to="/forgot-password">Forgot password</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/user/edit">Edit</v-list-tile>
          </v-list-group> -->
          <!--  ORGANISATION GROUP -->
          <!-- <v-list-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Organisation</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/company/edit">Edit</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/company/detail">Detail</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/company/apply-to-publisher">Apply to Publishers</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/company/manage-jobs">Manage Jobs</v-list-tile>
          </v-list-group> -->
          <!-- JOB GROUP -->
         <!--  <v-list-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Job</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/job/create">Create</v-list-tile>
            <v-list-tile to="/job/browse">Browse</v-list-tile>
          </v-list-group> -->
          <!-- PUBLISHER GROUP -->
          <!-- <v-list-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Publisher</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/publisher/edit">Edit</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/publisher/manage-organisations">Manage Organisations</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/publisher/manage-jobs">Manage Jobs</v-list-tile>
          </v-list-group> -->
          <!-- ADMIN GROUP -->
          <!-- <v-list-group no-action>
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>Admin</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/admin/manage-users">Manage users</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/admin/manage-organisations">Manage organisations</v-list-tile>
            <v-list-tile v-if="isLoggedIn" to="/admin/manage-publishers">Publishers list</v-list-tile>
          </v-list-group> -->
        </v-list>
      </v-navigation-drawer>
    </v-flex>
    <v-spacer class="hidden-sm-and-down"></v-spacer>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['getStatus', 'isLoggedIn', 'currentUser', 'isAdmin', 'isPublisher'])
  },
  data () {
    return {
      drawer: false
    }
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push('/login')
    }
  }
}
</script>
